export const buildCustomerCreatePayload = (form) => {
  const name = String(form?.name ?? "").trim();
  if (!name) {
    throw new Error("Il nome cliente è obbligatorio.");
  }
  if (name.length > 120) {
    throw new Error("Il nome cliente non può superare 120 caratteri.");
  }

  const normalizeOptional = (value) => {
    const normalized = String(value ?? "").trim();
    return normalized || null;
  };

  return {
    name,
    email: normalizeOptional(form?.email),
    phone: normalizeOptional(form?.phone),
    preferred_staff_id: normalizeOptional(form?.preferred_staff_id),
  };
};
